import React, { useState } from "react";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { FileCheck2, Loader2 } from "lucide-react";
import { API } from "../../App";

export const SignoffPdfButton = ({ signoff, testId }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/handover/signoffs/${signoff.id}/pdf`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
      if (!res.ok) throw new Error("Could not download the sign-off PDF");
      const url = URL.createObjectURL(await res.blob());
      const a = Object.assign(document.createElement("a"), { href: url, download: (res.headers.get("Content-Disposition") || "").match(/filename="(.+)"/)?.[1] || "handover-signoff.pdf" });
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  const date = new Date(signoff.signed_at).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  return (
    <Button size="sm" variant="outline" onClick={download} disabled={busy} className="border-green-300 text-green-800 hover:bg-green-50" data-testid={testId} title="Download the signed handover record">
      {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <FileCheck2 className="w-3.5 h-3.5 mr-1" />}Signed off {date}
    </Button>
  );
};
